
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-receipts",
      function () {
        return require("private-next-pages/track-receipts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-receipts"])
      });
    }
  